module.exports = __webpack_public_path__ + "img/3.ddf1265e.png";